<template>
    <div>
        <div>
            <el-tooltip content="Xóa" placement="top" :open-delay="500">
                <a @click="enablePopup">
                    <FAIcon icon="fa fa-trash icn" :class="{ 'disabled-icon' : isDeleted}" />
                </a>
            </el-tooltip>
        </div>

        <el-dialog :title="`Bạn chắc chắn muốn xóa tài liệu đã chọn?`" :visible.sync="deleteDialogVisible">
            <div>
                Tài liệu sẽ bị xóa vĩnh viễn, bạn có muốn tiếp tục?
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="deleteDialogVisible = false">Trở về</el-button>
    <el-button type="danger" @click="handleDeleteDocument">Xóa</el-button>
  </span>
        </el-dialog>
    </div>

</template>

<script>
import {hasRoleAdmin} from '@/services/user_service'
import {apiDeleteGroupDocument} from '@/services/group_management_service'
import FAIcon from '@/components/common/FAIcon.vue'

export default {
    name: 'DocumentDelete',
    data() {
        return {
            deleteDialogVisible: false,
        }
    },
    props: ['info', 'isDeleted'],
    components: {FAIcon},
    methods: {
        enablePopup() {
            if (!this.isDeleted) {
                this.deleteDialogVisible = true
            }
        },
        async handleDeleteDocument() {
            // 1:
            // 2:
            let res = await apiDeleteGroupDocument(this.info.groupId, [this.info.documentIds])
            console.log('delete : ', res)

            if (res != null && res.status === 'SUCCESS') {
                this.$message({
                    message: res.description,
                    type: 'success'
                })
                this.$data.deleteDialogVisible = false
                this.$emit('success')

            } else {
                this.$message({
                    message: 'Có lỗi xảy ra',
                    type: 'error'
                })
            }
        }
    },
    computed: {
        hasRoleAdmin: () => {
            return hasRoleAdmin()
        }
    }
}
</script>
<style scoped>
.icn {
    color: orangered;
    cursor: pointer;
}

.icn.disabled-icon {
    color: gray;
    opacity: 0.5;
    cursor: default;
}
</style>
